<div id="increase-size">
    <router-outlet></router-outlet>
</div>